import classNames from 'classnames/bind';

import Styles from './styles.module.scss';

import withComponentName from '../../decorators/withComponentName';

const cx = classNames.bind(Styles);

const DashedLineComponent = ({ section, coords }) => {
  const dashClass = cx('dashed',
    {
      new_to_investing: section === 'new_to_investing',
      just_start: section === 'just_start',
      trending_topics: section === 'trending_topics',
      trending_stories: section === 'trending_stories',
      integrate_news: section === 'integrate_news',
      global_coverage: section === 'global_coverage',
      global_coverage_mobile: section === 'global_coverage_mobile',
    });

  return (
    <svg className={dashClass}>
      <path className={Styles.dashed_line} d={coords} />
    </svg>
  );
};

export default withComponentName(DashedLineComponent);
